import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "search" */ '../views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "search" */ '../views/Login.vue')
  },
  {
    path: '/verification',
    name: 'verification',
    meta: {
      requiresAuth: false,
    },
    component: () => import( '../views/Verification.vue')
  },
  {
    path: '/detail/:id',
    name: 'detail',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "details" */ '../views/Detail.vue')
  } 

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
